import React from 'react'
import './header.scss'

const Header = () => {
  return (
    <header className="header">
      <h1>Not another <span className="glowing">Todo App?!</span></h1>
    </header>
  )
}

export default Header